import moment from "moment";
import "moment/locale/es";
import { cuentaMask, dineroDisabledMask } from '../Components/Items';
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

const reporteInsumosMasVendidosPdf = (values) => {
    const empresa = values.empresa || {};
    const logoBiwo = values.logoBiwo || {};
    let filtrados = [];

    // --- FILTROS ---
    if (values.clientes !== 0 && values.clientes && values.clientes.length > 0) {
        let textoFiltrado = '';
        values.clientes.forEach((valueCliente) => {
            textoFiltrado += `${(valueCliente.persona ? valueCliente.nombre : (valueCliente.nombre + ' ' + valueCliente.apellidoPaterno + ' ' + valueCliente.apellidoMaterno)) + valueCliente.razonSocial + " - " + valueCliente.rfc}\n`;
        });
        filtrados.push([{ text: 'Clientes:', style: 'subheader' }, { text: textoFiltrado, style: 'textoChico' }]);
    }

    if (values.vendedores !== 0 && values.vendedores && values.vendedores.length > 0) {
        let textoFiltrado = '';
        values.vendedores.forEach((valueVendedores) => {
            textoFiltrado += `${valueVendedores.nombre + " " + valueVendedores.apellidoPaterno + " " + valueVendedores.apellidoMaterno}\n`;
        });
        filtrados.push([{ text: 'Vendedores:', style: 'subheader' }, { text: textoFiltrado, style: 'textoChico' }]);
    }

    if (values.filtrarProyecto === 1) {
        let textoFiltrado = '';
        values.proyectos.forEach((valueProyectos) => {
            textoFiltrado += `${valueProyectos.nombre}\n`;
        });
        filtrados.push([{ text: 'Proyectos:', style: 'subheader' }, { text: textoFiltrado, style: 'textoChico' }]);
    }

    if (values.filtrarProyecto === 2) {
        filtrados.push([
            { text: 'Unidad de Negocio:', style: 'subheader' },
            {
                text: `${cuentaMask(values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 + values.unidadDeNegocio.nivel5)} - ${values.unidadDeNegocio.nombre}`,
                style: 'textoChico'
            }
        ]);
    }

    if (filtrados.length === 0) {
        filtrados.push([
            { text: 'No tiene filtrados adicionales', style: 'subheader' },
            { text: '', style: 'textoChico' }
        ]);
    }

    let headerTabla = [
        { text: 'Clave', style: 'tituloTabla' },
        { text: 'Cód. Barras', style: 'tituloTabla' },
        { text: 'Descripción', style: 'tituloTabla' },
        { text: 'Familia', style: 'tituloTabla' },
        { text: 'Marca', style: 'tituloTabla' },
        { text: 'Tipo', style: 'tituloTabla' },
        { text: 'Cant.', style: 'tituloTabla' },
        { text: 'P. Unit', style: 'tituloTabla' }
    ];

    let anchosTabla = ['8%', '10%', '20%', '8%', '8%', '8%', '6%', '8%'];

    if (values.mostrarCostos) {
        headerTabla.push(
            { text: 'Costo Total', style: 'tituloTabla' },
            { text: 'Ingreso Total', style: 'tituloTabla' },
            { text: 'Utilidad', style: 'tituloTabla' }
        );
        anchosTabla.push('8%', '8%', '8%'); 
    } else {
        headerTabla.push({ text: 'Ingreso Total', style: 'tituloTabla' });
        anchosTabla.push('24%'); 
    }

    // --- SEPARACIÓN POR MONEDAS ---
    const tablasDinamicas = [];
    const porMoneda = {};

    (values.insumos || []).forEach((insumo) => {
        const monedaKey = insumo.moneda || "MXN";
        if (!porMoneda[monedaKey]) porMoneda[monedaKey] = [];
        porMoneda[monedaKey].push(insumo);
    });

    let granTotalCantidad = 0;
    let granTotalCostos = 0;
    let granTotalIngresos = 0;
    let granTotalUtilidad = 0;

    Object.keys(porMoneda).forEach((moneda) => {
        const insumosMoneda = porMoneda[moneda];

        let totalCantidad = 0;
        let totalCostos = 0;
        let totalIngresos = 0;
        let totalUtilidad = 0;

        const filasInsumos = insumosMoneda.map((item) => {
            totalCantidad += parseFloat(item.cantidad || 0);
            totalCostos += parseFloat(item.costoTotal || 0);
            totalIngresos += parseFloat(item.ingresoTotal || 0);
            totalUtilidad += parseFloat(item.utilidad || 0);

            let fila = [
                { text: item.clave || 'N/A', style: 'textoTabla', alignment: 'left' },
                { text: item.codigoBarras || 'N/A', style: 'textoTabla', alignment: 'center' },
                { text: item.descripcion || '', style: 'textoTabla', alignment: 'left' },
                { text: item.familia || 'N/A', style: 'textoTabla', alignment: 'center' },
                { text: item.marca || 'N/A', style: 'textoTabla', alignment: 'center' },
                { text: item.tipoInsumo || 'N/A', style: 'textoTabla', alignment: 'center' },
                { text: item.cantidad || 0, style: 'textoTabla', alignment: 'right' },
                { text: dineroDisabledMask(item.precioUnitario), style: 'textoTabla', alignment: 'right' }
            ];

            if (values.mostrarCostos) {
                fila.push({ text: dineroDisabledMask(item.costoTotal), style: 'textoTabla', alignment: 'right' });
            }
            
            fila.push({ text: dineroDisabledMask(item.ingresoTotal), style: 'textoTabla', alignment: 'right' });

            if (values.mostrarCostos) {
                fila.push({ text: dineroDisabledMask(item.utilidad), style: 'textoTabla', alignment: 'right' });
            }

            return fila;
        });

        granTotalCantidad += totalCantidad;
        granTotalCostos += totalCostos;
        granTotalIngresos += totalIngresos;
        granTotalUtilidad += totalUtilidad;

        let filaTotales = [
            { text: `TOTALES GLOBALES (${moneda}):`, style: 'totalChico', alignment: 'left', colSpan: 6, border: [true, true, true, true], fillColor: '#cccccc' },
            {}, {}, {}, {}, {},
            { text: round2Decimals(totalCantidad), style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' },
            { text: '', style: 'totalChico', border: [true, true, true, true], fillColor: '#cccccc' }
        ];

        if (values.mostrarCostos) {
            filaTotales.push({ text: dineroDisabledMask(totalCostos), style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' });
        }

        filaTotales.push({ text: dineroDisabledMask(totalIngresos), style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' });

        if (values.mostrarCostos) {
            filaTotales.push({ text: dineroDisabledMask(totalUtilidad), style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' });
        }

        const headerClonado = headerTabla.map(col => ({ ...col }));

        tablasDinamicas.push(
            { text: `Moneda: ${moneda}`, style: "subheader", margin: [0, 5, 0, 2] },
            {
                style: 'tableExample',
                table: {
                    widths: anchosTabla,
                    headerRows: 1,
                    body: [
                        headerClonado, 
                        ...filasInsumos,
                        filaTotales
                    ]
                },
                layout: {
                    fillColor: (rowIndex) => rowIndex % 2 === 0 && rowIndex !== 0 ? "#e8e8e8" : "#ffffff",
                    hLineWidth: (i, node) => 1,
                    vLineWidth: (i, node) => 1,
                    hLineColor: () => '#adaaaa',
                    vLineColor: () => '#adaaaa',
                }
            },
            { text: "", margin: [0, 0, 0, 10] }
        );
    });

    let filaGranTotal = [
        { text: 'GRAN TOTAL:', style: 'totalChico', alignment: 'left', colSpan: 6, border: [true, true, true, true], fillColor: '#aaaaaa' },
        {}, {}, {}, {}, {},
        { text: round2Decimals(granTotalCantidad), style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#aaaaaa' },
        { text: '', style: 'totalChico', border: [true, true, true, true], fillColor: '#aaaaaa' },
    ];
    if (values.mostrarCostos) {
        filaGranTotal.push({ text: dineroDisabledMask(granTotalCostos), style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#aaaaaa' });
    }
    filaGranTotal.push({ text: dineroDisabledMask(granTotalIngresos), style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#aaaaaa' });
    if (values.mostrarCostos) {
        filaGranTotal.push({ text: dineroDisabledMask(granTotalUtilidad), style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#aaaaaa' });
    }
    tablasDinamicas.push({
        style: 'tableExample',
        table: { widths: anchosTabla, body: [filaGranTotal] },
        layout: { hLineWidth: () => 1, vLineWidth: () => 1, hLineColor: () => '#aaaaaa', vLineColor: () => '#aaaaaa' }
    });

    function round2Decimals(num) {
        return Math.round((num + Number.EPSILON) * 100) / 100;
    }


    var dd = {
        pageOrientation: 'landscape',
        pageSize: 'LETTER',
        pageMargins: [20, 20, 20, 60],
        footer: { image: 'logoBiwo', alignment: 'center', width: 80 },
        images: {
            logo: empresa?.logo?.base64Completa,
            logoBiwo: logoBiwo?.base64Completa,
        },
        content: [
            {
                style: 'tableExample',
                table: {
                    widths: ['15%', '55%', '30%'],
                    layout: 'noBorders',
                    body: [
                        [
                            ...HeaderEmpresaCard(
                                empresa, 
                                !empresa?.deshabilitarRegimenFiscal, 
                                false, 
                                {
                                    border: [false, false, false, false],
                                    table: {
                                        headerRows: 1,
                                        widths: ['100%'],
                                        body: [
                                            [{ text: 'Fecha Inicial:', style: 'subheader', alignment: 'center' }],
                                            [{ text: moment(values.fechaInicial).locale('es').format('LL'), style: 'textoChico', alignment: 'center' }],
                                            [{ text: 'Fecha Final:', style: 'subheader', alignment: 'center' }],
                                            [{ text: moment(values.fechaFinal).locale('es').format('LL'), style: 'textoChico', alignment: 'center' }],
                                            [{ text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center' }],
                                            [{ text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center' }],
                                        ]
                                    },
                                    layout: 'noBorders'
                                }
                            )
                        ]
                    ]
                }
            },
            { text: 'REPORTE DE INSUMOS MÁS VENDIDOS', style: 'tableHeaderIzquierda', margin: [0, 5, 0, 10] },

            // --- FILTRADOS ---
            { text: 'Datos de filtrado:' },
            {
                style: 'tableExample',
                table: {
                    widths: ['15%', '85%'],
                    layout: { defaultBorder: false },
                    body: filtrados,
                },
                layout: {
                    hLineWidth: (i, node) => 1,
                    vLineWidth: (i, node) => 1,
                    hLineColor: () => '#adaaaa',
                    vLineColor: () => '#adaaaa',
                    hLineStyle: (i, node) => (i === 0 || i === node.table.body.length) ? null : { dash: { length: 2, space: 1 } },
                    vLineStyle: (i, node) => (i === 0 || i === node.table.widths.length) ? null : { dash: { length: 2 } },
                }
            },
            
            { text: "", margin: [0, 0, 0, 5] },
            ...tablasDinamicas
        ],
        styles: {
            header: { fontSize: 9, bold: true },
            subheader: { fontSize: 8, bold: true },
            tableExample: { margin: [0, 5, 0, 5] },
            tableHeader: { bold: true, fontSize: 12, color: 'black', alignment: 'center' },
            tableHeaderIzquierda: { bold: true, fontSize: 14, color: 'black', alignment: 'center' },
            textoChico: { fontSize: 8 },
            tituloTabla: { fontSize: 7, bold: true, fillColor: '#cccccc', style: 'subheader', alignment: 'center', border: true },
            textoTabla: { fontSize: 7, italics: false }, 
            totalChico: { fontSize: 7, bold: true, fillColor: '#cccccc', alignment: 'right', border: true }
        }
    };
    return dd;
};

export default reporteInsumosMasVendidosPdf;